<template>
    <v-btn
        :color="isTablet ? '' : 'primary'"
        :class="buttonClass"
        @click="navigateHome"
        :large="!isTablet"
    >
        <v-icon left :size="iconSize">mdi-arrow-left</v-icon>
        {{ isTablet ? 'Packlisten' : 'Zurück zu den Packlisten' }}
    </v-btn>
</template>

<script>
export default {
    name: 'BackButton',
    props: {
        layout: {
            type: String,
            default: 'tablet', // 'tablet' or 'desktop'
            validator: (value) => ['tablet', 'desktop'].includes(value)
        }
    },
    computed: {
        isTablet() {
            return this.layout === 'tablet';
        },
        buttonClass() {
            return {
                'back-button-tablet': this.isTablet,
                'back-button-desktop': !this.isTablet
            };
        },
        iconSize() {
            return this.isTablet ? '18' : '20';
        }
    },
    methods: {
        async navigateHome() {
            if (document.fullscreenEnabled) {
                document.exitFullscreen();
            }

            window.history.back();
        }
    }
}
</script>

<style scoped>
.back-button-tablet {
    min-width: 100px;
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 0.9rem;
    text-transform: none;
    font-weight: 600;
    border-radius: 0 !important;
    flex-shrink: 0;
    background-color: #2196F3 !important;
    color: white !important;
    border: none !important;
    box-shadow: inset -4px 0 5px -2px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease;
    padding: 0 8px !important;
    margin: 0 !important;
    line-height: 1 !important;
    vertical-align: top;
}

.back-button-tablet .v-btn__content {
    height: 40px !important;
    line-height: 40px !important;
    padding: 0 !important;
    margin: 0 !important;
}

.back-button-desktop {
    width: 100%;
    height: 44px;
    font-size: 1rem;
    text-transform: none;
    font-weight: 500;
    border-radius: 8px;
    margin-bottom: 12px;
}

.back-button-tablet:hover {
    background-color: #1976D2 !important;
    box-shadow: inset -4px 0 8px -2px rgba(0, 0, 0, 0.3);
}

.back-button-desktop:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
    transition: all 0.2s ease;
}
</style>
